import script from "./SpecialistCard.vue?vue&type=script&setup=true&lang=js"
export * from "./SpecialistCard.vue?vue&type=script&setup=true&lang=js"

import "./SpecialistCard.vue?vue&type=style&index=0&id=52225ce2&lang=postcss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52225ce2"]])

export default __exports__